<template>
  <div>
    <nav-title :color="false" :title="'Recording parent goals'" />
    <section class="container">
      <detail-practice
        class="container px-sm-5"
        v-if="state"
        :planAnswers="getPracticeAnswers"
        :Mid="Mid"
        :skillName="getSkillName.text"
      />
      <new-practice
        class="container px-sm-5"
        v-else
        :skillQuest="updatedPracticeQuestionList"
        :Mid="Mid"
        :skillName="getSkillName.text"
      />
    </section>
  </div>
</template>
<script>
import navTitle from "@/components/general/navTitle.vue";
import newPractice from "@/components/practice/newPractice.vue";
import detailPractice from "@/components/practice/detailPractice.vue";
import { mapGetters } from "vuex";
import store from "@/store";

export default {
  components: {
    navTitle,
    newPractice,
    detailPractice
  },
  data() {
    return {
      Mid: this.$route.params.Mid,
      state: null
    };
  },
  methods: {
    getAnswers() {
      let responses = false;
      this.getPracticeAnswers.forEach(element => {
        if (element.parent_reponses) responses = true;
      });
      return responses;
    }
  },
  mounted() {
    this.state = this.getAnswers();
  },
  computed: {
    ...mapGetters("planning", [
      "getSkillName",
      "getPracticeQuestionList",
      "getPracticeAnswers",
      "getPlanAnswers"
    ]),
    ...mapGetters("user", ["getUserId"]),
    updatedPracticeQuestionList(){
      return this.getPracticeQuestionList.map(pq=>{
        return {
          ...pq,
          parent_reponses: !!(this.getPlanAnswers&&this.getPlanAnswers.find(pa=>pa.parent_reponses && pq.related_plan_question==pa.id))
        }
      })
    }
  },
  beforeRouteEnter(to, from, next) {
    let skill = to.params.Mid;
    let parent = store.getters["user/getUserId"];
    let data = { parent: parent, skill: skill };
    Promise.all([
      store.dispatch("planning/FetchPracticeQuestionList", skill),
      store.dispatch("planning/FetchSkillName", skill),
      store.dispatch("planning/FetchPracticeAnswers", data),
      store.dispatch("planning/FetchPlanAnswers", data)
    ]).then(() => {
      next();
    });
  }
};
</script>
